/* global __APP_VERSION__, __APP_COMMIT__, __APP_COMMIT_SHORT__, __APP_BUILD_DATE__, __APP_BUILD_TIME__ */

const readGlobal = (name: string, fallback: string): string => {
  try {
    const value = (globalThis as Record<string, unknown>)[name]

    return typeof value === 'string' && value.length > 0 ? value : fallback
  } catch {
    return fallback
  }
}

export const APP_VERSION =
  typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : readGlobal('__APP_VERSION__', '0.0.0')

export const APP_COMMIT =
  typeof __APP_COMMIT__ !== 'undefined' ? __APP_COMMIT__ : readGlobal('__APP_COMMIT__', 'unknown')

export const APP_COMMIT_SHORT =
  typeof __APP_COMMIT_SHORT__ !== 'undefined' ? __APP_COMMIT_SHORT__ : readGlobal('__APP_COMMIT_SHORT__', 'unknown')

export const APP_BUILD_DATE =
  typeof __APP_BUILD_DATE__ !== 'undefined' ? __APP_BUILD_DATE__ : readGlobal('__APP_BUILD_DATE__', '')

export const APP_BUILD_TIME =
  typeof __APP_BUILD_TIME__ !== 'undefined' ? __APP_BUILD_TIME__ : readGlobal('__APP_BUILD_TIME__', '')

export interface VersionPayload {
  version: string
  commit: string
  commitShort: string
  buildDate: string
  buildTime: string
}
